import script from "./SocketDebugWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SocketDebugWidget.vue?vue&type=script&setup=true&lang=js"

import "./SocketDebugWidget.vue?vue&type=style&index=0&id=5f53dabc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f53dabc"]])

export default __exports__